export default [
  {
    id: "bloom-fm",
    title: "Bloom FM",
    theme_colours: {
      light: "#FFDD22",
      dark: "#FFA905"
    },
    client: "Digital Distribution Networks",

    bee: "/images/projects/bee.png",
    introduction:
      "An award-winning music streaming service with over 1 million registered users.",
    description_1:
      "Bloom blended free streaming, genre and artist-based radios, music discovery tools, and a local library player with a catalogue of 22 million tracks. Our apps rose to #1 in the App Stores and we won UK User Experience Awards for our captivating and innovative design and usability. ",
    description_2:
      "Bloom effortlessly handled 100,000 concurrent users and was capable of scaling to 10x that without adding extra servers or optimisations. We built it (including computers, servers, and salaries) with a team that ranged from 10-20 people, on a technical and graphical design budget of £3m over 2.5 years. Every aspect, from music ingestion and storage to hosting was managed in-house to create the best value for our investors.",
    deliverables: [
      "iOS native, Android, Windows Phone & Web Apps",
      "Bespoke ingestion pipeline for import, transcoding, tagging and storage of millions of audio assets from multiple sources",
      "Storage of over 1.5 petabytes of audio assets with redundancy across multiple data centers",
      "Card payment processing system that integrated with HSBC and PayPal"
    ],
    services: [
      {
        name: "Product and Brand development",
        description: ""
      },
      {
        name: "Design and UX",
        description: ""
      },
      {
        name: "Backend and Frontend development",
        description: ""
      },
      {
        name: "Devops and Infrastructure",
        description:
          "Highly scalable, self hosted hardware and software infrastructure"
      },
      {
        name: "Data Services: custom-built bespoke pipelines",
        description: ""
      }
    ],
    platformsExcerpt: "Mobile, Web",
    platforms: [
      {
        name: "ObjC iOS app",
        description: ""
      },
      {
        name: "Java Android app",
        description: ""
      },
      {
        name: "C#",
        description: ""
      },
      {
        name: "C++",
        description: ""
      },
      {
        name: "jQuery",
        description: ""
      },
      {
        name: "Linux LVS",
        description: ""
      },
      {
        name: "Zabbix",
        description: ""
      },
      {
        name: "Puppet",
        description: ""
      },
      {
        name: "Graphite",
        description: ""
      },
      {
        name: "NGNIX",
        description: ""
      },
      {
        name: "GlusterFS",
        description: ""
      },
      {
        name: "Redis",
        description: ""
      },
      {
        name: "RabbitMQ",
        description: ""
      },
      {
        name: "Shaolinq",
        description: "Our powerful ORM and LINQ provider for C# and .NET"
      },
      {
        name: "Streaming Kit",
        description: "Our custom-built streaming service"
      },
      {
        name: "Platform.NET",
        description:
          "Our custom-built cross-platform library of useful classes and extensions for C# and .NET"
      }
    ],
    year: "2010-14",
    hero_image: {
      url: "/images/projects/bloom-header.png",
      name: "Image #1"
    },
    featured_image: {
      url: "/images/projects/bloom-featured.jpg",
      name: "Featured image"
    },
    homepage_image: {
      url: "/images/projects/bloom-featured.jpg",
      name: "Featured image"
    },
    images: [
      {
        url: "/images/projects/bloom-featured.jpg",
        name: "Image #1"
      },
      {
        url: "/images/projects/bloom-2.jpg",
        name: "Image #2"
      },
      {
        url: "/images/projects/bloom-3.jpg",
        name: "Image #3"
      },
      {
        url: "/images/projects/bloom-4.jpg",
        name: "Image #3"
      }
    ],
    url: "https://www.bloom.fm",
    meta_data: [
      {
        title: "App Store Ranking",
        description: "",
        value: "#1 in Music Apps"
      },
      {
        title: "Number of users",
        description: "",
        value: "1 million+"
      },
      {
        title: "Funds raised",
        description: "",
        value: "£3 million"
      },
      {
        name: "Shaolinq",
        description: "Our powerful ORM and LINQ provider for C# and .NET"
      },
      {
        name: "Streaming Kit",
        description: "Our custom-built streaming service"
      }
    ]
  },

  {
    id: "global-radio",
    title: "Global Radio",
    theme_colours: {
      light: "#7DC6EF",
      dark: "#3E77BC"
    },
    client: "Global Radio",
    introduction:
      "An on-demand broadcast archiving, retrieval and publishing service.",
    description_1:
      "Global is home to some of the UK's most popular radio stations including Heart, Capital and Classic FM. Our task was to develop an internal audio recording and playback system to archive their live radio streams, and offer a new 7-day listen again service.",
    description_2:
      "We delivered a ground-up distributed system that continuously archived broadcast radio, even in the event of a complete failure of all but one node. The system we developed is still in operation today.",
    services: [
      {
        name: "Backend and Frontend development",
        description: ""
      },
      {
        name: "Data Services: custom-built bespoke pipelines",
        description: ""
      }
    ],
    platformsExcerpt: "Web",
    platforms: [
      {
        name: "Microsoft .NET",
        description: ""
      },
      {
        name: "C++",
        description: ""
      },
      {
        name: "RabbitMQ",
        description: ""
      },
      {
        name: "libuv",
        description: ""
      },
      {
        name: "Angular",
        description: ""
      },
      {
        name: "Shaolinq",
        description: "Our powerful ORM and LINQ provider for C# and .NET"
      },
      {
        name: "GLADIATOR",
        description:
          "Our custom-built ad insertion app for targeted online radio"
      }
    ],
    year: "2014-15",
    hero_image: {
      url: "/images/projects/global-header.png",
      name: "Image #1"
    },
    featured_image: {
      url: "/images/projects/global-featured.jpg",
      name: "Featured image"
    },
    homepage_image: {
      url: "/images/projects/global-featured.jpg",
      name: "Featured image"
    },
    images: [
      {
        url: "/images/projects/global-3up.jpg",
        name: "Image #1"
      }
    ],
    url: "http://www.global.com"
  },
  {
    id: "kastr",
    title: "Kastr",
    backgroundImage: "/images/projects/kastr-bk.jpg",
    theme_colours: {
      light: "#F93157",
      dark: "#C50025"
    },
    client: "Kastr",
    introduction: "Virtual spaces and engaging experiences. ",
    description_1:
      "Kastr was a mobile-first subscription-based platform, featuring original shows with deeply engaging online experiences. Users could create content, interact in real-time, and engage with features like chat, polls and tipping. We partnered with high profile social influencers to appeal to a wide audience and create a platform for fan engagement.",
    description_2:
      "We built Kastr with low latency video streaming, using HLS to deliver multiple video streams at different quality levels for optimal performance on mobile devices with varying network speeds. All our development was done in-house to create the best value for our Investors including hosting everything on our own servers, and managing our own IT infrastructure.",
    meta_data: [
      {
        title: "Investment raised",
        description: "",
        value: "£4.5 million"
      }
    ],
    services: [
      {
        name: "Product and Brand development",
        description: ""
      },
      {
        name: "Design and UX",
        description: ""
      },
      {
        name: "Backend and Frontend development",
        description: ""
      },
      {
        name: "Devops and Infrastructure",
        description: ""
      },
      {
        name: "Data Services: custom-built bespoke pipelines",
        description: ""
      }
    ],
    platformsExcerpt: "Mobile, Web",
    platforms: [
      {
        name: "Microsoft .NET",
        description: ""
      },
      {
        name: "Swift",
        description: ""
      },
      {
        name: "Java for Android",
        description: ""
      },
      {
        name: "Redis",
        description: ""
      },
      {
        name: "RabbitMQ",
        description: ""
      },
      {
        name: "WebAPI",
        description: ""
      },
      {
        name: "NGINX",
        description: ""
      },
      {
        name: "Shaolinq",
        description: "Our powerful ORM and LINQ provider for C# and .NET"
      },
      {
        name: "Streaming Kit",
        description: "Our custom-built streaming service"
      }
    ],
    year: "2016",
    hero_image: {
      url: "/images/projects/kastr-header.png",
      name: "Image #1"
    },
    featured_image: {
      url: "/images/projects/kastr-featured.jpg",
      name: "Featured image"
    },
    homepage_image: {
      url: "/images/projects/kastr-featured.jpg",
      name: "Featured image"
    },
    images: [
      {
        url: "/images/projects/kastr-1.jpg",
        name: "Image #1"
      },
      {
        url: "/images/projects/kastr-2.jpg",
        name: "Image #2"
      },
      {
        url: "/images/projects/kastr-3.jpg",
        name: "Image #3"
      }
    ],
    url: "https://itunes.apple.com/gb/app/kastr/id1114540965"
  },
  {
    id: "ira-services",
    title: "IRA Services",
    theme_colours: {
      light: "#01417D",
      dark: "#00284D"
    },
    client: "ISCP",
    introduction:
      "Product development for US-based investment giant IRA Services Trust.",
    description_1:
      "We built a modern cloud-based platform for IRAST used by both their employees and customers. The platform allowed IRAST to expand their business by offering a 'Custody as a Service' (CaaS) solution to non-custodial wealth management companies seeking to add custodial services to their product suites.",
    description_2:
      "The platform we developed significantly increased the number of customer accounts and the total value of IRAST’s custodial holdings. Furthermore, our software played a role in enhancing the valuation of IRA Services Trust, contributing to its https://techcrunch.com/2019/03/28/forge-acquires-ira-services-to-expand-offering-for-private-company-shares/ by Forge Global in 2019. Our collaboration with Forge continues today.",
    deliverables: [
      "Customizable white label sign-up process",
      "Self-service client portal for managing all aspects of a self-directed US retirement account",
      "Employee portal to replace the legacy back office system",
      "Developer portal for seamless integration with new institutional partners leveraging the CaaS platform we built"
    ],
    services: [
      {
        name: "Product development",
        description: ""
      },
      {
        name: "Design and UX",
        description: ""
      },
      {
        name: "Backend and Frontend development",
        description: ""
      },
      {
        name: "Devops and Infrastructure",
        description: ""
      },
      {
        name: "Data Services: custom-built bespoke pipelines",
        description: ""
      },
      {
        name: "Historical data migrations",
        description: ""
      },
      {
        name: "Cyber Security and Resource Access Control",
        description: ""
      },
      {
        name: "Compliance and Regulation",
        description: ""
      }
    ],
    platformsExcerpt: "Web",
    platforms: [
      {
        name: "Microsoft .NET",
        description: ""
      },
      {
        name: "Azure",
        description: ""
      },
      {
        name: "WebAPI",
        description: ""
      },
      {
        name: "React",
        description: ""
      },
      {
        name: "Angular",
        description: ""
      },
      {
        name: "Shaolinq",
        description: "Our powerful ORM and LINQ provider for C# and .NET"
      }
    ],
    year: "2015 - 2019",
    hero_image: {
      url: "/images/projects/ira-hero.png",
      name: "Image #1"
    },
    featured_image: {
      url: "/images/projects/ira-featured.jpg",
      name: "Featured image"
    },
    homepage_image: {
      url: "/images/projects/ira-featured.jpg",
      name: "Featured image"
    },
    images: [
      {
        url: "/images/projects/ira-3.jpg",
        name: "Image #1"
      },
      {
        url: "/images/projects/ira-1.jpg",
        name: "Image #1"
      },
      {
        url: "/images/projects/ira-2.jpg",
        name: "Image #1"
      }
    ],
    url: "https://www.iraservices.com",
    meta_data: [
      {
        title: "Customer accounts",
        description: "",
        value: "1.4 million+"
      },
      {
        title: "Funds Under Management",
        description: "",
        value: "$3 billion+"
      }
    ]
  },
  {
    id: "forge-trust",
    title: "Forge Trust",
    theme_colours: {
      light: "#2a73a0",
      dark: "#3689bc"
    },
    client: "Forge Trust",
    introduction:
      "Fueling Forge’s bold digital transformation in the self-directed IRA industry. ",
    description_1:
      "In 2019, Forge Global https://techcrunch.com/2019/03/28/forge-acquires-ira-services-to-expand-offering-for-private-company-shares/ IRA Services Trust, one of our longstanding clients. We worked closely with Forge during their due diligence process, examining IRAST’s technical and financial standing. This included supporting their thorough review of operations to ensure compliance with the Sarbanes-Oxley Act of 2002 (SOX). ",
    description_2:
      "Since the acquisition, our highly skilled team has provided invaluable technical and product development services as Forge ventured into the complex realm of offering custodial and administrative services to millions of self-directed individual retirement account holders. Our collaboration with Forge is ongoing.",
    services: [
      {
        name: "Product development",
        description: ""
      },
      {
        name: "Backend and Frontend development",
        description: ""
      },
      {
        name: "Devops and Infrastructure",
        description: ""
      },
      {
        name: "Data Services: custom-built bespoke pipelines",
        description: ""
      },
      {
        name: "Historical data migrations",
        description: ""
      },
      {
        name: "Cyber Security and Resource Access Control",
        description: ""
      },
      {
        name: "Compliance and Regulation",
        description: ""
      },
      {
        name: "Development process restructuring",
        description: ""
      }
    ],
    platformsExcerpt: "Web",
    platforms: [
      {
        name: "Microsoft .NET 6",
        description: ""
      },
      {
        name: "React",
        description: ""
      },
      {
        name: "OAS spec first development of Microservices",
        description: ""
      },
      {
        name: "WebAPI",
        description: ""
      },
      {
        name: "Azure",
        description: ""
      },
      {
        name: "AWS",
        description: ""
      },
      {
        name: "RDS",
        description: ""
      },
      {
        name: "Elasticache",
        description: ""
      },
      {
        name: "Terraform",
        description: ""
      },
      {
        name: "GitHub Actions",
        description: ""
      },
      {
        name: "ELK Stack",
        description: ""
      },
      {
        name: "Grafana, Prometheus, Jaeger",
        description: ""
      }
    ],
    year: "2019 - Present",
    hero_image: {
      url: "/images/projects/forge-trust-hero.png",
      name: "Image #1"
    },
    featured_image: {
      url: "/images/projects/forgetrust-1.jpg",
      name: "Featured image"
    },
    homepage_image: {
      url: "/images/projects/forgetrust-1.jpg",
      name: "Featured image"
    },
    images: [
      {
        url: "/images/projects/forgetrust-1.jpg",
        name: "Image #1"
      },
      {
        url: "/images/projects/forgetrust-2.jpg",
        name: "Image #1"
      },
      {
        url: "/images/projects/forgetrust-3.jpg",
        name: "Image #1"
      }
    ],
    url: "https://www.forgetrust.com",
    meta_data: [
      {
        title: "Accounts",
        description: "",
        value: "2.5 million+"
      },
      {
        title: "Assets Under Management",
        description: "",
        value: "$5.5 billion+"
      }
    ]
  },

  {
    id: "ncfx",
    title: "NCFX",
    theme_colours: {
      light: "#fda95f",
      dark: "#fd67bf"
    },
    client: "NCFX",

    introduction:
      "Small business, big data: building NCFX’s next-gen digital platform.",
    description_1:
      "NCFX produces and publishes the world's only continuous, FCA-regulated benchmark rates for Spot and Forward FX. They provide a range of advanced tools for post- and pre-trade analysis, along with streaming analytics, to help their customers evaluate foreign exchange trading costs and achieve optimal execution.",
    description_2:
      "In 2021, NCFX welcomed a new leadership team. King Street was initially engaged to assess the company’s technical maturity and provide recommendations. Since then, we have become a trusted development partner, collaborating with their in-house development team on multiple projects to deliver their next-generation platform. Our partnership with NCFX is ongoing.",
    services: [
      {
        name: "Design and UX",
        description: ""
      },
      {
        name: "Backend and Frontend development",
        description: ""
      },
      {
        name: "Devops and Infrastructure",
        description: ""
      },
      {
        name: "Data Services: custom-built bespoke pipelines",
        description: ""
      },
      {
        name: "Historical data migrations",
        description: ""
      },
      {
        name: "Comprehensive technical maturity assessment",
        description: ""
      },
      {
        name: "Development process restructuring",
        description: ""
      }
    ],
    platformsExcerpt: "Web",
    platforms: [
      {
        name: "FIX Protocol",
        description: ""
      },
      {
        name: "Java",
        description: ""
      },
      {
        name: "Python",
        description: ""
      },
      {
        name: "React",
        description: ""
      },
      {
        name: "Typescript",
        description: ""
      },
      {
        name: "Postgres Timescale DB",
        description: ""
      },
      {
        name: "Redis",
        description: ""
      },
      {
        name: "Docker",
        description: ""
      },
      {
        name: "AWS cloud native services",
        description: "Lambda, Firehose, S3, Amplify, ECS/Fargate, APIGW"
      }
    ],
    year: "2021 - Present",
    hero_image: {
      url: "/images/projects/ncfx-hero.png",
      name: "Image #1"
    },
    featured_image: {
      carousel_url: "/images/projects/ncfx-1.jpg",
      url: "/images/projects/NCFX-1.jpg",
      name: "Featured image"
    },
    homepage_image: {
      url: "/images/projects/NCFX-1.jpg",
      name: "Featured image"
    },
    images: [
      {
        url: "/images/projects/NCFX-1.jpg",
        name: "Image #1"
      },
      {
        url: "/images/projects/NCFX-4.jpg",
        name: "Image #1"
      },
      {
        url: "/images/projects/NCFX-3.jpg",
        name: "Image #1"
      }
    ],
    url: "https://www.newchangefx.com"
  },
  {
    id: "orchidz",
    title: "Orchidz",
    theme_colours: {
      light: "#4c0572",
      dark: "#6457B7"
    },
    client: "Orchidz",

    introduction:
      "A visually stunning, mobile-first NFT marketplace for the Asian market.",
    description_1:
      "Orchidz is a mobile-first NFT marketplace where users can import, list and sell NFTs using Blockchain technology. The platform caters to the Asian market, enabling users to purchase NFTs deployed on the Blockchain as an NFT asset.",
    description_2:
      "Designing the site posed unique challenges in translating and displaying diverse languages and characters, while also identifying and adapting to the specific UI, UX, and Information Architecture patterns of various Asian marketplaces.",
    services: [
      {
        name: "Design and UX",
        description: ""
      },
      {
        name: "Backend and Frontend development",
        description: ""
      },
      {
        name: "Devops and Infrastructure",
        description: ""
      },
      {
        name: "Data Services: custom-built bespoke pipelines",
        description: ""
      }
    ],
    platformsExcerpt: "Mobile, Web",
    platforms: [
      {
        name: "React",
        description: ""
      },
      {
        name: "NextJS",
        description: ""
      },
      {
        name: "Storybook",
        description: ""
      },
      {
        name: "Tailwind CSS",
        description: ""
      },
      {
        name: "Strapi CMS",
        description: ""
      },
      {
        name: "Vercel",
        description: ""
      },
      {
        name: "Thirdweb",
        description: ""
      },
      {
        name: "Blockchain",
        description: ""
      },
      {
        name: "Google Cloud Platform",
        description: "Cloud Build, Cloud Run, Cloud SQL, Redis"
      }
    ],
    year: "2023",
    hero_image: {
      url: "/images/projects/orchidz-hero.png",
      name: "Image #1"
    },
    featured_image: {
      url: "/images/projects/orchidz-featured.jpg",
      name: "Featured image"
    },
    homepage_image: {
      url: "/images/projects/orchidz-featured.jpg",
      name: "Featured image"
    },
    images: [
      {
        url: "/images/projects/orchidz-1.jpg",
        name: "Image #1"
      },
      {
        url: "/images/projects/orchidz-2.jpg",
        name: "Image #1"
      },
      {
        url: "/images/projects/orchidz-3.jpg",
        name: "Image #1"
      },
      {
        url: "/images/projects/orchidz-4.jpg",
        name: "Image #1"
      }
    ],
    url: "https://www.newchangefx.com"
  }
];
